import DateTimeUtils from '../../common/utils/DateTimeUtils';
import TimeUtils from '../../common/utils/TimeUtils';

import { DateViewMode } from '../../common/value-types/DateViewMode';

export default class ScheduleDateRolloverController {
  constructor(commandDataModel, counterparty) {
    this.commandDataModel = commandDataModel;

    this.prescheduleDateRolloverPeriod = counterparty.prescheduleDateRolloverPeriod;
    this.prescheduleDateRolloverWarning = counterparty.prescheduleDateRolloverWarning;
    this.realtimeDateRolloverPeriod = counterparty.realtimeDateRolloverPeriod;
    this.realtimeDateRolloverWarning = counterparty.realtimeDateRolloverWarning;
  }

  activate() {
    this.commandDataModel.updateProperties(this.retrieveCurrentDateStatus());

    this.checkDateRolloverListener = this.checkDateRollover.bind(this);
    this.dateRolloverTimeout = setInterval(this.checkDateRolloverListener, 1000);
  }

  deactivate() {
    clearInterval(this.dateRolloverTimeout);
  }

  retrieveCurrentDateStatus() {
    var rolloverPeriod, rolloverWarningSeconds;

    switch (this.commandDataModel.dateViewMode) {
      case DateViewMode.weccPreschedule:
        rolloverPeriod = this.prescheduleDateRolloverPeriod;
        rolloverWarningSeconds = this.prescheduleDateRolloverWarning;
        break;
      case DateViewMode.weccRealtime:
        rolloverPeriod = this.realtimeDateRolloverPeriod;
        rolloverWarningSeconds = this.realtimeDateRolloverWarning;
        break;
      default:
        rolloverPeriod = TimeUtils.formatTime(0, 0, 0);
        rolloverWarningSeconds = 0;
        break;
    }

    var currentTime = DateTimeUtils.getNow();
    var currentTimeAdvanced = TimeUtils.addTimeOffset(currentTime, rolloverPeriod);
    var currentDateAdvanced = DateTimeUtils.getDate(currentTimeAdvanced);

    var currentTimeAdvancedWarning = TimeUtils.addSecondsOffset(currentTimeAdvanced, rolloverWarningSeconds);
    var currentDateAdvancedWarning = DateTimeUtils.getDate(currentTimeAdvancedWarning);

    return {
      currentDate: currentDateAdvanced,
      showDateRolloverWarning: !DateTimeUtils.areDatesEqual(currentDateAdvanced, currentDateAdvancedWarning)
    };
  }

  checkDateRollover() {
    var currentDateStatus = this.retrieveCurrentDateStatus();

    var propertyUpdates = {};

    if (!DateTimeUtils.areDatesEqual(currentDateStatus.currentDate, this.commandDataModel.currentDate))
      propertyUpdates.currentDate = currentDateStatus.currentDate;

    if (currentDateStatus.showDateRolloverWarning !== this.commandDataModel.showDateRolloverWarning)
      propertyUpdates.showDateRolloverWarning = currentDateStatus.showDateRolloverWarning;

    this.commandDataModel.updateProperties(propertyUpdates);

    if (propertyUpdates.currentDate !== undefined)
      this.commandDataModel.dateRollingOver();
  }
}